
export default class BookingItemHandlerType {

    static OPEN_INSTALLATION = 'open'

    static SEND_EVENT = 'event'

}
